var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageFlex word",style:({color: _vm.color || 'var(--redColor)'}),on:{"click":_vm.onClick}},[(_vm.iconLeft)?_c('i',{staticClass:"iconfont left",class:_vm.iconName}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.word))]),(!_vm.iconLeft)?_c('i',{staticClass:"iconfont right",class:_vm.iconName,style:({fontSize: _vm.fontSize})}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }